/* eslint-disable no-magic-numbers */
import { useCallback } from 'react';
import styled from 'styled-components';
import { Icon } from '../../icon';
import { Avatar } from '../../avatar';
import { Initials } from '../../initials';

const StyledItemLabel = styled.span<{ $showAvatar?: boolean, $canRemove?: boolean }>`
	border-radius: 14px;
	display: flex;
	align-items: center;
	background-color: ${props => props.theme.form.multiSelectInput.itemBackground};
	padding: 3px ${props => props.$canRemove ? 6 : 10}px 3px ${props => props.$showAvatar ? 4 : 10}px;
	height: 22px;
	font-size: 13px;
	line-height: 1;
	text-overflow: ellipsis;
	overflow: hidden;
	column-gap: 6px;
	box-sizing: border-box;
`;

const StyledIconButton = styled(Icon)`
	padding: 0;
	border: 0;
	background-color: transparent;
	color: ${props => props.theme.form.multiSelectInput.removeIcon};
	cursor: pointer;
	font-size: 15px;
	display: flex;
	align-items: center;

	&:hover {
		color: ${props => props.theme.form.multiSelectInput.removeIconHover};
	}
`;

const StyledName = styled.span`
	text-overflow: ellipsis;
	overflow: hidden;
	color: ${props => props.theme.form.multiSelectInput.itemColor};
	line-height: 1;
`;

export function InputChip({ item, onRemove, canRemove, showAvatar } : {
	item: { id: string, name: string, avatarUrl?: string },
	onRemove: (id: string) => void,
	canRemove?: boolean,
	showAvatar?: boolean,
}) {
	const onCrossClick = useCallback((e: React.MouseEvent) => {
		e.stopPropagation();
		onRemove(item.id);
	}, [item.id, onRemove]);

	return <StyledItemLabel $canRemove={canRemove} $showAvatar={showAvatar}>
		{showAvatar && 
		(item.avatarUrl ? <Avatar size={20} url={item.avatarUrl} /> : <Initials name={item.name} />)}
		<StyledName>{item.name}</StyledName>
		{canRemove && <StyledIconButton icon={'x-circle-solid'} onClick={onCrossClick} />}
	</StyledItemLabel>;
}
